import { Component, input, TemplateRef } from "@angular/core";
import { UrlTree } from "@angular/router";

export interface Breadcrumb {
  id: string;
  label: string;
  routerLink?: UrlTree;
}

@Component({
  selector: "app-breadcrumb",
  standalone: false,
  templateUrl: "./breadcrumb.component.html",
  styleUrl: "./breadcrumb.component.scss",
})
export class BreadcrumbComponent {
  config = input.required<Breadcrumb[]>();

  customTpl = input<Record<string, TemplateRef<any>>>();

  get breadCrumb() {
    return this.config();
  }

  get templates() {
    if (!this.customTpl()) return null;
    return this.customTpl();
  }
}
